import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-base pt-8 mb-6" }
const _hoisted_2 = { class: "flex flex-row gap-5 pl-0" }
const _hoisted_3 = ["onClick"]

import { ref, onMounted } from "vue";
import PageHeaderComponent from "@/components/global/PageHeaderComponent.vue";
import EditSelectionComponent from "@/modules/main/components/internal-tools/EditSelectionComponent.vue";
import ArchiveSelectionComponent from "@/modules/main/components/internal-tools/ArchiveSelectionComponent.vue";
import AddSchoolComponent from "@/modules/main/components/internal-tools/AddSchoolComponent.vue";
import CreateSchoolGroupComponent from "@/modules/main/components/internal-tools/CreateSchoolGroupComponent.vue";
import TrackSelectionComponent from "@/modules/main/components/internal-tools/TrackSelectionComponent.vue";
import { useLearnerStore } from "@/stores/learnerStore";
import { useUserStore } from "@/stores/userStore";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'InternalView',
  setup(__props) {

const learnerStore = useLearnerStore();
const btnOption = ref("Edit");
const options = ['Create', 'Add', 'Edit', 'Track', 'Push', 'Archive'];

const setOption = (option: string) => {
  btnOption.value = option;
  learnerStore.setArchiveOptions(false);
};

const userStore = useUserStore();
const router = useRouter();

onMounted(() => {

  // Route to admin if the user's designation is not include "Internal"
  if (!userStore.user?.designation?.includes("Internal")) {
    router.push("/main/admin");
  }
  
  if (learnerStore.archiveOptions) {
    btnOption.value = "Archive";
  }
});

const activeClass = ref(
  "py-2 px-3 bg-[#155EEF] rounded-md text-sm text-white font-medium lg:font-semibold"
);

const inactiveClass = ref(
  "py-2 px-3 rounded-full text-sm text-[#667085] font-medium lg:font-semibold"
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageHeaderComponent, { pageHeading: 'Internal' }),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (option) => {
          return _createElementVNode("button", {
            key: option,
            class: _normalizeClass(btnOption.value === option ? activeClass.value : inactiveClass.value),
            onClick: ($event: any) => (setOption(option))
          }, _toDisplayString(_ctx.$t(`internal_tools.top_bar.${option.toLowerCase()}`)), 11, _hoisted_3)
        }), 64))
      ])
    ]),
    (btnOption.value === 'Create')
      ? (_openBlock(), _createBlock(CreateSchoolGroupComponent, { key: 0 }))
      : _createCommentVNode("", true),
    (btnOption.value === 'Add')
      ? (_openBlock(), _createBlock(AddSchoolComponent, { key: 1 }))
      : _createCommentVNode("", true),
    (btnOption.value === 'Edit')
      ? (_openBlock(), _createBlock(EditSelectionComponent, { key: 2 }))
      : _createCommentVNode("", true),
    (btnOption.value === 'Archive')
      ? (_openBlock(), _createBlock(ArchiveSelectionComponent, { key: 3 }))
      : _createCommentVNode("", true),
    (btnOption.value === 'Track')
      ? (_openBlock(), _createBlock(TrackSelectionComponent, { key: 4 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})